import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountProfileEdit" })
export default class AccountProfileEdit extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public countries: any[] = [];
    public companyTypes: any[] = [];
    public profileTypes: any[] = [];
    public provinces: any[] = [];
    public profileSegments: any[] = [];
    public editData: any = null;
    public formData: any = { profileSegment: null, country: null, profileType: null };
    public validationErrors: any[] = [];
    public isPrivacyPolicyShow: boolean = false;
    public privacyPolicy: string = null;
    public isCompany: boolean = false;
    public isItalyCountry: boolean = false;

    @Watch("formData.profileType") onFormDataProfileTypChanged(value: any) {
        value === "Company" ? this.isCompany = true : (this.isCompany = false, this.formData.company = null, this.formData.companyType = null);
    }

    @Watch("formData.country") onFormDataCountryTypChanged(value: any) {
        value === "IT" ? this.isItalyCountry = true : this.isItalyCountry = false;
    }

    @Prop() readonly returnUrl: string;
    @Prop() readonly isCompanyRequired: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.getData();
    }

    public async getData() {
        this.editData = (await Axios.post(this.routes.MyBremboPartsProfile_GetProfileEditData + "?iscompanyrequired=" + this.isCompanyRequired, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        this.formData.name = this.editData.name;
        this.formData.surname = this.editData.surname;
        this.formData.profileType = this.editData.profileType;
        this.formData.company = this.editData.company;
        this.formData.companyType = this.editData.companyType == "" ? null : this.editData.companyType;
        this.formData.country = this.editData.country == "" ? null : this.editData.country;
        this.formData.location = this.editData.location;
        this.formData.address = this.editData.address;
        this.formData.postCode = this.editData.postCode;
        this.formData.zone = this.editData.zone;
        this.formData.profileSegment = this.editData.profileSegment;
        this.countries = this.editData.countries;
        this.companyTypes = this.editData.companyTypes;
        this.profileTypes = this.editData.profileTypes;
        this.provinces = this.editData.provinces;
        this.profileSegments = this.editData.profileSegments;

        this.formData.isCompanyRequired = this.isCompanyRequired;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.MyBremboPartsProfile_ProfileEdit, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

            if (result.redirectUrl || this.returnUrl) {
                window.location.href = result.redirectUrl ? result.redirectUrl : (this.returnUrl ? this.returnUrl : "/");
            }

            await this.getData();

            this.isSuccess = true;
            setTimeout(x => { this.isSuccess = false }, 2500);
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};